import i18n from "@/common/i18n";
import Layout from '@/layout/index';
const router = [
  {
    path: '/data',
    component: Layout,
    redirect: '/data/info',
    meta: {
      auth_key: 'view_report',
      child_auth_key: 'permission_data',
      auth: true,
      title: `${i18n.t("lang.k_013001")}`,
      name: 'dataMgr',
      icon: 'saasicon_charts_img'
    },
    children: [
      {
        path: 'info',
        component: () => import('@/views/StatisticsModule/dataInfo'),
        meta: {
          auth_key: 'view_report', child_auth_key: 'permission_data', title: `${i18n.t("lang.k_013002")}`, name: 'dataInfo'
        }
      },
      {
        path: 'live',
        component: () => import('@/views/StatisticsModule/dataLive'),
        meta: {
          auth_key: 'view_report', child_auth_key: 'permission_data', title: `${i18n.t("lang.k_013001")}`, name: 'dataLive'
        }
      }
    ]
  }
];
export default router;
